export const construirFecha = (dia, mes, ano) => {
  if (!dia || !mes || !ano) return null;

  const diaStr = dia.toString().padStart(2, "0");
  const mesStr = mes.toString().padStart(2, "0");
  const anoStr = ano.toString();

  return `${anoStr}-${mesStr}-${diaStr}`;
};
